// A line's status as the spec screens draw it — the donor's `LineStatusText`
// (`common.ts:225-235`) and `SPEC_ITEM_STATUS_COLORS` (`styles/shared.ts:1-5`),
// shared by the group menu's status rows (#805) and the Editor's status pill
// (#809), so a status's order and colour have one home.

export type SpecItemStatus = "finalized" | "in_progress" | "needs_attention";

/** `Object.values(LineStatusText)` — the order the donor lists them in. */
export const SPEC_ITEM_STATUSES: readonly SpecItemStatus[] = [
  "finalized",
  "in_progress",
  "needs_attention",
];

/** A status's dot colour, as the `--color-spec-item-*` tokens. */
export const SPEC_ITEM_STATUS_DOT: Record<SpecItemStatus, string> = {
  finalized: "bg-spec-item-finalized",
  in_progress: "bg-spec-item-in-progress",
  needs_attention: "bg-spec-item-needs-attention",
};
